var map = {
	"./": [
		9026,
		9
	],
	"./bit_burst/manifest": [
		2193,
		3
	],
	"./bit_burst/manifest.json": [
		2193,
		3
	],
	"./bit_burst/mmc_bit_burst_game": [
		5434,
		9,
		445,
		434
	],
	"./bit_burst/mmc_bit_burst_game.jsx": [
		5434,
		9,
		445,
		434
	],
	"./bit_burst/mmc_bit_burst_styles.css": [
		3747,
		9,
		747
	],
	"./core_striker/manifest": [
		1825,
		3
	],
	"./core_striker/manifest.json": [
		1825,
		3
	],
	"./core_striker/mmc_core_striker_game": [
		4148,
		9,
		445,
		148
	],
	"./core_striker/mmc_core_striker_game.jsx": [
		4148,
		9,
		445,
		148
	],
	"./core_striker/mmc_core_striker_styles.css": [
		3109,
		9,
		109
	],
	"./index": [
		9026,
		9
	],
	"./index.js": [
		9026,
		9
	],
	"./mem_link/manifest": [
		139,
		3
	],
	"./mem_link/manifest.json": [
		139,
		3
	],
	"./mem_link/mmc_mem_link_game": [
		4788,
		9,
		445,
		788
	],
	"./mem_link/mmc_mem_link_game.jsx": [
		4788,
		9,
		445,
		788
	],
	"./snake/cover.png": [
		6024,
		1,
		24
	],
	"./snake/manifest": [
		2579,
		3
	],
	"./snake/manifest.json": [
		2579,
		3
	],
	"./snake/mmc_snake_game": [
		4802,
		9,
		445,
		802
	],
	"./snake/mmc_snake_game.jsx": [
		4802,
		9,
		445,
		802
	],
	"./snake/mmc_snake_game_old": [
		5920,
		9,
		920
	],
	"./snake/mmc_snake_game_old.jsx": [
		5920,
		9,
		920
	],
	"./snake/mmc_snake_styles.css": [
		6595,
		9,
		595
	],
	"./snake/stats_manager": [
		42,
		9,
		42
	],
	"./snake/stats_manager.js": [
		42,
		9,
		42
	],
	"./tetromo/manifest": [
		4037,
		3
	],
	"./tetromo/manifest.json": [
		4037,
		3
	],
	"./tetromo/mmc_tetromo_game": [
		9238,
		9,
		445,
		238
	],
	"./tetromo/mmc_tetromo_game.jsx": [
		9238,
		9,
		445,
		238
	],
	"./tetromo/mmc_tetromo_styles.css": [
		1079,
		9,
		79
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, ids[1] | 16)
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 6682;
module.exports = webpackAsyncContext;